import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var BracketsRight = props => {
  var {
    BracketsRight: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BracketsRight');
  return null;
};
BracketsRight.displayName = 'JVR.BracketsRight';